export function ProductCardSkeleton() {
  return (
    <div className="product-card skeleton-card" aria-hidden="true">
      <div className="skeleton-image" />
      <div className="skeleton-line wide" />
      <div className="skeleton-line" />
    </div>
  );
}
